export default "__VITE_ASSET__DOD28zv5__"